import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { OAuthService } from "./../services/o-auth";
import { Router } from "@angular/router";
import {
  NavigationStart,
  NavigationEnd,
  Event as NavigationEvent,
} from "@angular/router";
import { ApiService } from "../services/api";
import { AngularFireDatabase } from "angularfire2/database";
import { AngularFireAuth } from "angularfire2/auth";
import { environment } from '../../environments/environment'
import { env } from "process";
import { ElasticService } from "app/services/elastic";
@Component({
  selector: "app-dashboard",
  templateUrl: "./full-layout.component.html",
})
export class FullLayoutComponent implements OnInit {
  public disabled = false;
  public user: any;
  public actProfile: any = {};
  public profiles: any[] = [];
  public status: { isopen: boolean } = { isopen: false };
  public toggleSidebar = true;
  // userData: [];
  public buttonText: any;
  public notCount = 0;
  constructor(
    private oAuthService: OAuthService,
    public fireAuth: AngularFireAuth,
    public router: Router,
    public apiService: ApiService,
    private fireDatabase: AngularFireDatabase,
    private cdr: ChangeDetectorRef,
    private elasticService: ElasticService,
  ) {
    this.buttonText = {};
  }
  public toggled(open: boolean): void {
    console.log("Dropdown is now: ", open);
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }
  logout() {
    this.router.navigate(["/login"]);

    this.oAuthService.logout();
  }
  public version  = ""
  async ngOnInit() {

    this.version = environment.version;
    console.log(this.version);

    this.user = this.oAuthService.getClub();
    $(".nav-link").click(function () {
      $("body").removeClass("sidebar-mobile-show");
    });


    // if (this.user) {
    let results = await this.apiService.list("user-profiles/" + this.user.uid);
    console.log(results);


    for (let i = 0; i < results.length; i++) {
      let result = await this.apiService.object("users/" + results[i].$key);
      if (results[i].isVerified) {
        if (results[i].status != undefined) {
          if (results[i].status == 1) {
            result.key = results[i].$key;
            this.profiles.push(Object.assign(result, results[i]));
          }
        } else {
          this.profiles.push(result);
        }
      }
    }
    console.log(this.profiles);
    this.save(this.user, false);

  }

 async save(profile, flag) {
    this.toggleSidebar = false
    this.buttonText = profile;
console.log(profile);

    if (flag) {
      profile.cid = profile.key;
      let req = {
        cid: profile.key,
        status: profile.status,
        type: profile.type,
        role: parseInt(profile.role + ""),
        name: profile.name,
      };

      this.user.uid = this.fireAuth.auth.currentUser.uid;
      this.user = Object.assign(this.user, req);
      if(this.user.type == 1 && (this.user.role == 3 || this.user.role == 2)){
        if(this.user.club){
          const queryParams = {
            index: "users",
            type: "club",
            "body/query/ids/values": [profile.key],
            // "body/query/bool/must/query_string/fields": ["uid^10"]
          };

          let clubs = await this.elasticService.search(queryParams)
          let currentClub;

          if (clubs["hits"].length) {
            currentClub = clubs["hits"][0]["_source"];
            currentClub["$key"] = clubs["hits"][0]["_id"];
          }
          if (!currentClub.club)
          {
            this.user.club.name = currentClub.name;
            this.user.club.cid = currentClub.$key
          }

            if(currentClub.bank)
            this.user.bank = currentClub.bank;
            if(currentClub.courses)
            this.user.courses = currentClub.courses;
            if(!this.user.club){
              this.user.club = currentClub;
            }
        }

      }
      this.oAuthService.setClub(this.user);
    }

    this.buttonText = profile;
    if (profile.club) {
      this.buttonText.name = profile.club.name

    }
    this.oAuthService.setClub(this.user);


    this.fireDatabase
      .object("user-notifications/" + profile.cid + "/count")
      .subscribe((ress) => {
        console.log(ress);

        if (ress.$exists()) {
          this.notCount = ress.$value;
        }
      });
    let club = this.oAuthService.getClub()
    this.cdr.detectChanges();

    this.profiles.map((p) => {
      if (p.key == profile.cid) {
        this.actProfile = p;
        if (p.username) {
          this.actProfile.fullName = p.username
        }
      }
    });
    this.toggleSidebar = true;
    if (flag) {

      if (this.user.type == 1) {
        return this.router.navigate(["/club-dashboard"]);
      } else if (this.user.type == 3) {
        return this.router.navigate(["/dashboard"]);
      } else if (this.user.type == 4) {
        return this.router.navigate(["/committee-dashboard"]);
      } else if (this.user.type == 5) {
        return this.router.navigate(["/company-dashboard"]);
      } else if (this.user.type == 6) {
        return this.router.navigate(["/society-dashboard"]);
      } else if (this.user.type == 7) {
        return this.router.navigate(["/tour-dashboard"]);
      }
    } else {

    }
  };
}
